import {
    React,
    useState,
    useContext,
    createContext
} from '@biletiniz/ui-core';

const ToastContext = createContext();

export const useToast = () => {
    return useContext(ToastContext);
};

function useProviderToast() {
    const [severity, setSeverity] = useState('error');
    const [message, setMessage] = useState('');
    const [onClose, setOnClose] = useState(null);

    return {
        severity,
        message,
        onClose,
        setSeverity,
        setMessage,
        setOnClose
    };
}

export function ToastProvider({ children }) {
    const toast = useProviderToast();
    return (
        <ToastContext.Provider value={toast}>{children}</ToastContext.Provider>
    );
}
